import { ReactElement } from 'react'
import styled from 'styled-components'

//----- Component -----//
const VideoAd = styled.div`
	 {
    padding-top: 10px;
    padding-bottom: 10px;
		min-height: 253px;
	}
`

export const YourbowVideo = ({ dataAdMapping = 'video' }): ReactElement => (
	<VideoAd
		className="ad-wrapper"
		id="div-video-ad"
		data-ad-mapping={dataAdMapping}
		data-ad-slot="Discover/video"
	></VideoAd>
)
